import React from "react";
import { Slider, Switch, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatMoney, formatPercent, getRowYieldPercent } from "./utils";
import { COST_SAVINGS_MARKS } from "../../../screens/Rankings/RankingsUtils";

const { Text } = Typography;

function CostBenefitAnalysis({
  formState,
  setFormState,
  slidersEnabled,
  markDirty,
  reviewRows,
}) {
  return (
    <section className="optimisation-review__section optimisation-review__card">
      <div className="optimisation-review__section-head">
        <Text strong>Cost Benefit Analysis</Text>
      </div>

      <div className="optimisation-review__sliders">
        <div className="optimisation-review__slider">
          <div className="optimisation-review__slider-label-row">
            <label>Optimization</label>
            <span>{formState.optimisationPercent}%</span>
          </div>
          <Slider
            className="optimisation-review__slider-control"
            value={formState.optimisationPercent}
            marks={COST_SAVINGS_MARKS}
            min={0}
            max={100}
            disabled={!slidersEnabled}
            tooltip={{ open: false }}
            onChange={(value) => {
              markDirty();
              setFormState((prev) => ({
                ...prev,
                optimisationPercent: value,
              }));
            }}
          />
        </div>
        <div className="optimisation-review__slider">
          <div className="optimisation-review__slider-label-row">
            <label>Yield</label>
            <div className="optimisation-review__yield-toggle">
              <Switch
                size="small"
                checked={formState.yieldEnabled}
                disabled={!slidersEnabled}
                onChange={(checked) => {
                  markDirty();
                  setFormState((prev) => ({
                    ...prev,
                    yieldEnabled: checked,
                    yieldPercent: checked
                      ? prev.yieldPercent
                      : getRowYieldPercent(reviewRows[0]),
                  }));
                }}
              />
              <span>{formState.yieldPercent}%</span>
            </div>
          </div>
          <Slider
            className="optimisation-review__slider-control"
            value={formState.yieldPercent}
            marks={COST_SAVINGS_MARKS}
            min={0}
            max={100}
            disabled={!slidersEnabled || !formState.yieldEnabled}
            tooltip={{ open: false }}
            onChange={(value) => {
              markDirty();
              setFormState((prev) => ({
                ...prev,
                yieldPercent: value,
              }));
            }}
          />
        </div>
      </div>

      <div className="optimisation-review__metrics">
        <div className="optimisation-review__metric optimisation-review__metric--blue">
          <span>Total Projected Savings</span>
          <strong>{formatMoney(formState.projectedSavings)}</strong>
        </div>
        <div className="optimisation-review__metric optimisation-review__metric--blue">
          <span>Total Estimated Savings</span>
          <strong>{formatMoney(formState.expectedSavings)}</strong>
        </div>
        <div className="optimisation-review__metric optimisation-review__metric--green">
          <span>Estimated Annual Savings</span>
          <strong>{formatMoney(formState.estimatedAnnualSavings)}</strong>
        </div>
        <div className="optimisation-review__metric optimisation-review__metric--green">
          <span>Total Savings Percentage</span>
          <strong>{formatPercent(formState.savingsPercentage)}</strong>
        </div>
      </div>

      <div className="optimisation-review__info">
        <InfoCircleOutlined />
        <span>Estimated values only. No maintenance schedules are modified.</span>
      </div>
    </section>
  );
}

export default React.memo(CostBenefitAnalysis);
